import Swal from 'sweetalert2';
import { DangerRight } from '../component/api/toastServices';
import { IconBasketDollar, IconInfoOctagon } from '@tabler/icons-react';

export const warning = (confirm) => {
  return Swal.fire({
    // title: 'Are you sure?',
    // text: "You won't be able to revert this!",
    // // iconHtml: IconInfoOctagon,
    // showCancelButton: true,
    // confirmButtonText: confirm,
    // customClass: {
    //   confirmButton: 'btn bg-second text-light m15-right',
    //   cancelButton: 'btn bg-darkGray text-light',
    // },
    // buttonsStyling: false,
     title: 'Are you sure?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#ff5e75',
    cancelButtonColor: '#6e6e6eef ',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
  });
};
export const AcceptWarning = (confirm) => {
  return Swal.fire({
    // title: "Are you sure?",
    text: 'Would you like to approve the withdrawal request?',
    // iconHtml: IconBasketDollar,
    icon : "question",
    showCancelButton: true,
    confirmButtonText: confirm,
    // customClass: {
    //   confirmButton: 'btn bg-green text-light',
    //   cancelButton: 'btn bg-darkGray text-light ms-2',
    // },
    // buttonsStyling: false,
  });
};
export const AcceptProductWarning = (confirm) => {
  return Swal.fire({
    // title: "Are you sure?",
    text: 'Would you like to approve the product request?',
    iconHtml: '<i className="ri-alert-line"></i>',
    showCancelButton: true,
    confirmButtonText: confirm,
    customClass: {
      confirmButton: 'btn bg-green text-light',
      cancelButton: 'btn bg-darkGray text-light ms-2',
    },
    buttonsStyling: false,
  });
};
export const RejectWarning = (confirm) => {
  return Swal.fire({
    // title: "Are you sure?",
    text: 'Would you like to reject the withdrawal request?',
    iconHtml: '<i className="ri-alert-line"></i>',
    showCancelButton: true,
    confirmButtonText: confirm,
    customClass: {
      confirmButton: 'btn bg-green text-light',
      cancelButton: 'btn bg-darkGray text-light ms-2',
    },
    buttonsStyling: false,
  });
};
export const RejectProductWarning = (confirm) => {
  return Swal.fire({
    // title: "Are you sure?",
    text: 'Would you like to reject the withdrawal request?',
    iconHtml: '<i className="ri-alert-line"></i>',
    showCancelButton: true,
    confirmButtonText: confirm,
    customClass: {
      confirmButton: 'btn bg-green text-light',
      cancelButton: 'btn bg-darkGray text-light ms-2',
    },
    buttonsStyling: false,
  });
};

export const permissionError = () => {
  return Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: "You don't have permission!",
  });
};

export const permissionErrorForDemo = (props) => {
  return DangerRight(`This is a demo ${props}, you can't delete.`);
};
